import { render, staticRenderFns } from "./VAOrder.vue?vue&type=template&id=7b0b04ee&lang=html"
import script from "./VAOrder.vue?vue&type=script&lang=js"
export * from "./VAOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports